
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import TableOrderSet from "@common/src/components/scope/table-order-set/index.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
const service = namespace("service");
const base = namespace("base");
@Component({
  components: { StandardFlag, SwitchStatus, TableOrderSet }
})
@Table("loadListData")
export default class TestingItemList extends Vue {
  @service.Action queryStationList;
  @service.Action insertStation;
  @service.Action updateStationBySort;
  @service.Action deleteStation;
  @base.Action getDictionaryList;
  @service.Action updateStationByStatus;
  dayjs = dayjs;
  switchState = true;
  showStationEdit = false;
  showDeleteModal: boolean = false;
  stationForm: any = {
    stationCode: "",
    stationName: "",
    stationType: ""
  };
  stationFormRules: any = {
    stationName: [{ required: true, message: t("v210831.please-enter-station"), trigger: "blur" }],
    stationType: [{ required: true, message: t("v210831.please-select-station-type"), trigger: "blur" }]
  };
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  stationList: any[] = [];
  created() {
    this.init();
  }
  searchStationName: string = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryStationList({
      stationName: this.searchStationName
    }).then(data => {
      this.stationList = data.data;
      return data;
    });
  }
  stationTypeList: any = [];
  async init() {
    this.loadListData();
    // 工位类型字典List
    this.getDictionaryList("station_type").then(data => {
      this.stationTypeList = data;
    });
  }
  handleShowCreate() {
    Object.keys(this.stationForm).forEach(key => {
      this.stationForm[key] = "";
    });
    this.showStationEdit = true;
  }
  activeRowData: any = {};
  handleShowEdit(row) {
    if (row.stationStatus === "10") {
      return;
    }
    this.activeRowData = row;
    this.stationForm = Object.assign({}, row);
    this.showStationEdit = true;
  }
  handleDelete(row) {
    if (row.stationStatus === "10") {
      return;
    }
    this.activeRowData = row;
    this.showDeleteModal = true;
  }
  handleDeleteStation() {
    this.deleteStation({
      stationCode: this.activeRowData.stationCode
    }).then(() => {
      this.$message.success(t("v210831.station-deleted-successfully"));
      this.showDeleteModal = false;
      this.loadListData();
    });
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.createStation();
      } else {
        console.log("error submit!!");
      }
    });
  }
  createStation() {
    this.insertStation(this.stationForm).then(() => {
      this.loadListData();
      this.$message.success(t("v210831.station-added-successfully"));
      this.showStationEdit = false;
      const refPay = this.$refs.stationForm as any;
      refPay.resetFields();
    });
  }
  handleEdit(row) {
    this.$router.push(`/marketing/card-template-edit/${row.cardTemplateCode}`);
  }
  handleView(row) {
    this.$router.push(`/marketing/card-template-view/${row.cardTemplateCode}`);
  }
  confirmUpdateStatus(status, selectedRow?) {
    this.updateStationByStatus({
      status: status,
      stationCode: selectedRow.stationCode
    }).then(() => {
      this.$message.success(
        status === 1 ? (t("setting.enable-successful") as string) : (t("setting.disable-success") as string)
      );
      this.loadListData();
    });
  }
  sortArrList(arr) {
    this.updateStationBySort({
      stationCodeArray: arr.map(item => {
        return item.stationCode;
      })
    }).then(() => {
      this.$message.success(t("setting.operate-successfully"));
      this.loadListData();
    });
  }
  handleOrderChange(type, index) {
    if (
      ((type === "upOne" || type === "upTop") && index === 0) ||
      ((type === "downOne" || type === "downBottom") && index === this.stationList.length - 1)
    ) {
      return;
    }
    let tmp;
    if (type === "upOne") {
      tmp = this.stationList[index];
      this.stationList[index] = this.stationList[index - 1];
      this.stationList[index - 1] = tmp;
      this.sortArrList(this.stationList);
    } else if (type === "downOne") {
      tmp = this.stationList[index];
      this.stationList[index] = this.stationList[index + 1];
      this.stationList[index + 1] = tmp;
      this.sortArrList(this.stationList);
    } else if (type === "upTop") {
      tmp = this.stationList[index];
      let arr = this.stationList;
      arr.splice(index, 1);
      arr.unshift(tmp);
      this.sortArrList(arr);
    } else if (type === "downBottom") {
      tmp = this.stationList[index];
      let arr = this.stationList;
      arr.splice(index, 1);
      arr.push(tmp);
      this.sortArrList(arr);
    }
  }
}
